import React from 'react'
import {Badge} from 'wix-ui-tpa/cssVars'
import {classes} from './badge.st.css'

export const BadgeExt = props => <Badge {...props} className={classes.root} />
